import React from "react";
import SectorLayout from "@/components/SectorLayout";
import data from "@/data/sectors/agriculture";
export default function SecteurAgriculture() { return <SectorLayout data={data} />; }
